import React, { useRef } from "react";
import InAWordResponsesBody from "./body";
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import { getDefaultWidgetConfigs, getRemoteConfigs, getEventDetailsHash } from '../utils';
import { getCommonDateRangeWithPresetFilterValue } from '../../../generic/Utils/commonUtils';

const InAWordResponses = (props) => {
    const { name, url, actionsData } = props;
    const defaultWidgetConfigs = getDefaultWidgetConfigs({ ...props, className: "grid-item-span-full-width" });
    const filterKey = 'respondedIn';
    const stateRef = useRef(null);

    // Helper function to extract filters from state
    const extractFiltersFromState = (state) => {
      const dateFilters = getCommonDateRangeWithPresetFilterValue(state, filterKey, 'responded_in_date_range');
      const connectionTypeValue = state?.connectionType?.data?.selectedValue;
      const userRoleValue = state?.userRole?.data?.selectedValue;
      
      return {
        ...dateFilters,
        ...(connectionTypeValue && { connection_type: connectionTypeValue }),
        ...(userRoleValue && { user_role: userRoleValue })
      };
    };

    const configBuilder = (state) => {
      return {
        remoteOptions: getRemoteConfigs(url, InAWordResponsesBody, { filters: extractFiltersFromState(state) })
      };
    };

    // Function to build URL with filter parameters for CSV export
    const buildUrlWithFilters = (baseUrl) => {
      const currentState = stateRef.current;
      if (!currentState) return baseUrl;

      const filterState = extractFiltersFromState(currentState);
      const params = new URLSearchParams();

      const filterKeys = ['responded_in_date_range', 'connection_type', 'user_role'];

      filterKeys.forEach((key) => {
        const value = filterState[key];
        if(value) params.append(key, value);
      })

      const queryString = params.toString();
      return queryString ? `${baseUrl}?${queryString}` : baseUrl;
    };

    const { actions, widgetConfig, state: widgetActionsState } = useWidgetActionsBuilder(actionsData, configBuilder, { 
      buildUrlWithFilters 
    });

    // Keep state reference updated
    stateRef.current = widgetActionsState;

    return (
      <ChrWidget
        { ...defaultWidgetConfigs }
        header={ name }
        loadersRowCount = {2}
        additionalLoaderClasses = "cui-height-170-important"
        headerActions={ actions.headerActions }
        headerActionsClass = "cui-mobile-action-padding ml-auto pr-1"
        widgetSpecificHeaderClasses = "cui-mobile-auto-height flex-wrap"
        { ...widgetConfig.remoteOptions }
      />
    )
};

export default InAWordResponses;